import Draggable from "react-draggable";
import {BigButton} from "./BigButton"; // The default
import {FaCheck, FaTimes} from 'react-icons/fa'
import {cleanBorder, errorColor, goodColor, primary45} from "../../utils/color";

//PC_FG_55
export default function DraggableSignature({ url, onEnd, onSet, onCancel }) {
  //PC_FG_56
  const styles = {
    container: {
      position: 'absolute',
      zIndex: 100000,
      border: `2px solid ${primary45}`,
    },
    controls: {
      position: 'absolute',
      right: 0,
      display: 'inline-block',
      backgroundColor: primary45,
      // borderRadius: 4,
    },
    smallButton: {
      display: 'inline-block',
      cursor: 'pointer',
      padding: 4,
    }
  }
  return (
    //PC_FG_58
    <Draggable bounds={{top:0,left:0,bottom:1000,right:900}} onStop={onEnd}>
      {/* //PC_FG_59 */}
      <div style={styles.container}>
        {/* //PC_FG_60 */}
        <div style={styles.controls}>
          {/* //PC_FG_61 */}
          <div style={styles.smallButton} onClick={onSet}><FaCheck color={goodColor}/></div>
          <div style={styles.smallButton} onClick={onCancel}><FaTimes color={errorColor}/></div>
        </div>
        {/* //PC_FG_62 */}
        <img src={url} width={150} style={styles.img} draggable={false} />
      </div>
    </Draggable>
  );
}
